import React from 'react'
import AdminPageWithSmartview from 'pages/app/AdminPageWithSmartview'
import * as UI from 'ui'
import TranslatedTitle from 'widgets/TranslatedTitle'
import { Translation, Translator } from '@morningtrain/react-translations'
import { Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import { CanUseModel } from '@morningtrain/react-auth'
import { Link } from '@morningtrain/react-navigation'
import { PaginationFilter } from '@morningtrain/react-filters'

export default function MyContracts (props) {
  return (
    <AdminPageWithSmartview withGlobalDepartmentFilter={false}>
      <Translator namespace='hr.contracts'>
        <UI.PageHeader title={<TranslatedTitle name='titles.my_contracts' />} />
        <Collection resourceName='employments.contracts' operationName='mine'>

          <UI.Card>
            <Table>
              <Columns.Text
                name='title'
                label={<Translation name='columns.name.label' />}
              />
              <Columns.Enum
                name='detailed_status'
                label={'status'}
                enum='detailed_contract_status'
              />
              <Columns.DateTime
                name='signed_at'
                label={<Translation name='columns.signed_at.label' />}
              />
              <Columns.Column>
                <UI.ButtonWrap>
                  <CanUseModel permission='app.contracts.sign_mine'>
                    <Link newTab route='app.contracts.sign_mine' parameters={{ contract: 'model:id' }}>
                      <UI.Button>
                        <Translation name='tablet.signing.sign_contract' />
                      </UI.Button>
                    </Link>
                  </CanUseModel>
                  <CanUseModel permission='app.contracts.file'>
                    <Link newTab route='app.contracts.file' parameters={{ contract: 'model:id' }}>
                      <UI.Button>
                        <UI.WithIcon icon={<UI.Icons.Download />} placement='right'>
                          <Translation name='actions.file' />
                        </UI.WithIcon>
                      </UI.Button>
                    </Link>
                  </CanUseModel>
                  <CanUseModel permission='app.contracts.zip'>
                    <Link newTab route='app.contracts.zip' parameters={{ contract: 'model:id' }}>
                      <UI.Button>
                        <UI.WithIcon icon={<UI.Icons.Download />} placement='right'>
                          <Translation name='actions.zip' />
                        </UI.WithIcon>
                      </UI.Button>
                    </Link>
                  </CanUseModel>
                </UI.ButtonWrap>
              </Columns.Column>
            </Table>
            <PaginationFilter />
          </UI.Card>
        </Collection>
      </Translator>
    </AdminPageWithSmartview>
  )
}
